import { PAGINA_HOME_USUARIO_INTERNO_SEM_PERMISSAO, PAGINA_HOME_GOVBR } from './../../tools/URL';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { RedefinirSenhaDTO } from 'src/app/entity/RedefinirSenhaDTO';
import {
  ERRO_AUTENTICACAO_FALHOU,
  MSG_LOGIN_USUARIO_DESATIVADO,
  OK_AUTENTICACAO, MSG_CADASTRO_USUARIO_GOV_BR, MENSAGEM_EXPIRAR_SESSAO, ERRO_RENOVAR_SESSAO, MSG_CADASTRO_PENDENTE_ATIVACAO_USUARIO_GOV_BR } from 'src/app/tools/Mensagens';
import { PAGINA_HOME, PAGINA_LOGIN, URL_API, USUARIO, montarUrlDoCliente } from 'src/app/tools/URL';
import { CadastroUsuario } from '../../entity/CadastroUsuario';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'src/app/environment';
import { KeycloakService } from 'keycloak-angular';
import { AtivarContaDTO } from 'src/app/entity/AtivarContaDTO';
import { Observable } from 'rxjs';
import { build } from '../../../build/build';

const JWT_TOKEN_KEY = 'AuthToken';
const CURRENT_USER = 'CurrentUser';
const JWT_TOKEN_KEY_GOV_BR = 'Token gov.br';
const TIMEOUT_SESSION = 'TimeoutSession';
const GOV_BR_REDIRECT_URL = 'GovBrRedirectUrl';
const AUTH_PROVIDER_KEY = 'AuthProvider';
const AUTH_PROVIDER_KEYCLOAK = 'KEYCLOAK';
const AUTH_PROVIDER_EXTERNO = 'EXTERNO';
const AUTH_PROVIDER_GOVBR = 'GOVBR';
const TEMPO_SESSAO =  60000;

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  usuarioDTO = {} as CadastroUsuario;
  url = PAGINA_HOME;

  constructor(private router: Router, private http: HttpClient, private keycloakService: KeycloakService) {}

  private limparEstadoGovBr(): void {
    localStorage.removeItem(JWT_TOKEN_KEY_GOV_BR);
    sessionStorage.removeItem(GOV_BR_REDIRECT_URL);
  }

  private limparProvedorAutenticacao(): void {
    localStorage.removeItem(AUTH_PROVIDER_KEY);
  }

  private definirProvedorAutenticacao(provedor: string): void {
    localStorage.setItem(AUTH_PROVIDER_KEY, provedor);
  }

  marcarAutenticacaoKeycloak(): void {
    this.definirProvedorAutenticacao(AUTH_PROVIDER_KEYCLOAK);
  }

  isAutenticadoViaKeycloak(): boolean {
    return localStorage.getItem(AUTH_PROVIDER_KEY) === AUTH_PROVIDER_KEYCLOAK;
  }

  private extrairMensagemErro(errorResponse: any): string {
    if (!errorResponse) {
      return 'Falha ao autenticar com o Gov.br.';
    }

    const erro = errorResponse.error;

    if (typeof erro === 'string' && erro.trim()) {
      return erro;
    }

    if (erro && erro.message) {
      return erro.message;
    }

    if (errorResponse.message) {
      return errorResponse.message;
    }

    return 'Falha ao autenticar com o Gov.br.';
  }

  private normalizarRedirecionamentoGovBr(url: string): string {
    if (!url) {
      return PAGINA_HOME_GOVBR;
    }

    let urlNormalizada = (url || '').trim();
    try {
      urlNormalizada = decodeURIComponent(urlNormalizada);
    } catch (e) {
      // Mantém valor original quando não estiver codificado.
    }

    if (!urlNormalizada || /^https?:\/\//i.test(urlNormalizada)) {
      return PAGINA_HOME_GOVBR;
    }

    if (!urlNormalizada.startsWith('/')) {
      urlNormalizada = '/' + urlNormalizada;
    }

    return urlNormalizada;
  }

  definirRedirecionamentoGovBr(url: string): string {
    const urlNormalizada = this.normalizarRedirecionamentoGovBr(url);
    sessionStorage.setItem(GOV_BR_REDIRECT_URL, urlNormalizada);
    return urlNormalizada;
  }

  obterRedirecionamentoGovBr(): string {
    const url = sessionStorage.getItem(GOV_BR_REDIRECT_URL);
    if (!url) {
      return PAGINA_HOME_GOVBR;
    }
    return this.normalizarRedirecionamentoGovBr(url);
  }

  consumirRedirecionamentoGovBr(): string {
    const url = this.obterRedirecionamentoGovBr();
    sessionStorage.removeItem(GOV_BR_REDIRECT_URL);
    return url;
  }

  login(email, senha, url) {

    const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');

    this.http.post(`${environment.settings.api.url + URL_API.PATH_AUTENTICAR_JWT}`, { email, senha }, { headers, responseType: 'text' })
      .subscribe(retorno => {

        if (url == null) { url = this.url; }

        if (retorno) {

          localStorage.clear();
          localStorage.setItem(JWT_TOKEN_KEY, retorno);

          this.getAuthenticatedUser().subscribe((usuario: CadastroUsuario) => {

              if (usuario.ativo == 'S') {

                usuario.senha = null;
                localStorage.setItem(CURRENT_USER, JSON.stringify(usuario));
                this.definirProvedorAutenticacao(AUTH_PROVIDER_EXTERNO);

                this.url = url;
                alert(OK_AUTENTICACAO(usuario.nome));

                this.keycloakService.isLoggedIn().then(isLoggedIn => {

                  if (isLoggedIn) {
                    this.keycloakService.logout(montarUrlDoCliente(environment.settings.clientWebUrl, PAGINA_HOME));

                    return;
                  }

                });

                this.router.navigate([url]);

              }
              else{
                alert(MSG_LOGIN_USUARIO_DESATIVADO);
              }

          });

        } else {

          alert(ERRO_AUTENTICACAO_FALHOU);

        }

      }, messageError => { alert(this.extrairMensagemErro(messageError)); });

  }

  get usuarioLogado(): CadastroUsuario {

    return localStorage.getItem(CURRENT_USER) ? JSON.parse(localStorage.getItem(CURRENT_USER)) : { nome: '' };

  }

  atualizarDataNascimentoUsuarioLogado(dataNascimento: string, prioridadePessoaIdosa?: boolean): void {

    const usuario = this.usuarioLogado;
    usuario.dataNascimento = dataNascimento as any;
    if (prioridadePessoaIdosa !== undefined && prioridadePessoaIdosa !== null) {
      usuario.prioridadePessoaIdosa = prioridadePessoaIdosa;
    }
    this.usuarioDTO = usuario;
    localStorage.setItem(CURRENT_USER, JSON.stringify(usuario));

  }

  getTokenUsuarioExterno() {

    return localStorage.getItem(JWT_TOKEN_KEY);

  }

  getTokenUsuarioGovBr() {

    return localStorage.getItem(JWT_TOKEN_KEY_GOV_BR);

  }

  isUsuarioExternoLogado() {

    return this.getTokenUsuarioExterno() !== null;

  }

  isUsuarioGovBr() {

    const tokenGovBr = this.getTokenUsuarioGovBr();

    return tokenGovBr !== null
      && tokenGovBr.trim() !== ''
      && tokenGovBr !== 'null'
      && tokenGovBr !== 'undefined';

  }

  possuiRoles(routeRoles: string[]) {

    return !this.isUsuarioExternoLogado() &&
            routeRoles === undefined ||
            routeRoles.length === 0 ||
            routeRoles.some(roleRota => this.keycloakService.isUserInRole(roleRota));

  }

  redefinirSenhaEmail(email) {

    this.http.get(`${environment.settings.api.url + URL_API.PATH_REDEFINIR_SENHA_EMAIL}`, { params: { email }, responseType: 'text' })
    .subscribe(retorno => {

      alert(retorno);
      this.router.navigate([PAGINA_LOGIN]);

    }, err => alert(err));

  }

  esqueciMinhaSenhaEmail(email, cpfCnpj) {

    this.http.get(`${environment.settings.api.url + URL_API.PATH_ESQUECI_MINHA_SENHA}`, { params: { email, cpfCnpj }, responseType: 'text' })
    .subscribe(retorno => {

      alert(retorno);
      this.router.navigate([PAGINA_LOGIN]);

    }, err => alert(err));

  }

  redefinirSenha(redefinirSenhaDTO: RedefinirSenhaDTO) {

    const headers = new HttpHeaders().set('Content-Type', 'application/json;');

    this.http.post(`${environment.settings.api.url + URL_API.PATH_REDEFINIR_SENHA}`, redefinirSenhaDTO, { headers, responseType: 'text'})
      .subscribe(retorno => {

        alert(retorno);
        this.router.navigate([PAGINA_LOGIN]);

      }, err => console.log(err));

  }

  getAuthenticatedUser() {

    const headers = new HttpHeaders().set('External-Authorization', this.getTokenUsuarioExterno());

    return this.http.get(`${environment.settings.api.url + URL_API.PATH_USUARIO_AUTENTICADO}`, { headers });

  }

  logoutUser(): void {

    this.keycloakService.isLoggedIn().then(isLoggedIn => {

      localStorage.removeItem(JWT_TOKEN_KEY);
      localStorage.removeItem(CURRENT_USER);
      localStorage.removeItem(TIMEOUT_SESSION);
      this.limparProvedorAutenticacao();
      this.limparEstadoGovBr();

      if (isLoggedIn) {

        this.keycloakService.logout(montarUrlDoCliente(environment.settings.clientWebUrl, PAGINA_LOGIN));

        return;

      }

      this.router.navigate([PAGINA_LOGIN]);

    });

  }

  logoutUserUsuarioInternoSemPermissao(){
    this.logoutUserRedirectTarget(PAGINA_HOME_USUARIO_INTERNO_SEM_PERMISSAO);
  }

  // Método que realiza o logout sem realizar redirecionamento para alguma tela de login especificada
  logoutUserRedirectTarget(pagina: string): void {

    this.keycloakService.isLoggedIn().then(isLoggedIn => {

      localStorage.removeItem(JWT_TOKEN_KEY);
      localStorage.removeItem(CURRENT_USER);
      localStorage.removeItem(TIMEOUT_SESSION);
      this.limparProvedorAutenticacao();
      this.limparEstadoGovBr();

      if (isLoggedIn) {

        this.keycloakService.logout(montarUrlDoCliente(environment.settings.clientWebUrl, pagina));

        return;

      }

      this.router.navigate([pagina]);

    });

  }

  ativarConta(ativarContaDTO: AtivarContaDTO) {

    const headers = new HttpHeaders().set('Content-Type', 'application/json;');

    this.http.post(`${environment.settings.api.url + URL_API.PATH_ATIVAR_CONTA}`, ativarContaDTO, { headers, responseType: 'text'})
      .subscribe(retorno => {

        alert(retorno);
        this.router.navigate([PAGINA_LOGIN]);

      }, err => console.log(err));

  }



  tokenAcessoGovBr(authorizationCode, state = null) {
  if (state) {
    this.definirRedirecionamentoGovBr(state);
  }
  const headers = new HttpHeaders().set('Content-Type', 'application/json;');

    this.http.post(`${environment.settings.api.url + URL_API.PATH_TOKEN_ACESSO_GOVBR}`, authorizationCode, { headers, responseType: 'text'})
      .subscribe(token => {

        if (token) {

          localStorage.clear();
          localStorage.setItem(JWT_TOKEN_KEY_GOV_BR, token);
          this.definirProvedorAutenticacao(AUTH_PROVIDER_GOVBR);

          this.cpfUsuarioGovBr(token);

        } else {

          alert(ERRO_AUTENTICACAO_FALHOU);

        }

      }, messageError => { alert(this.extrairMensagemErro(messageError)); });

  }

  cpfUsuarioGovBr(token) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json;');

      this.http.post(`${environment.settings.api.url + URL_API.PATH_CPF_USUARIO_GOV_BR}`, token, { headers, responseType: 'text'})
        .subscribe(cpfUsuarioGovBr => {

          if (cpfUsuarioGovBr) {

            this.pesquisarUsuarioPorCpf(cpfUsuarioGovBr).subscribe((usuario) => {

              if (usuario) {
                localStorage.setItem(CURRENT_USER, JSON.stringify(usuario));
                const dataExpiracao = new Date();
                dataExpiracao.setTime(Date.now() + TEMPO_SESSAO);
                localStorage.setItem(TIMEOUT_SESSION, dataExpiracao.getTime().toString());

                const redirecionamentoPosLogin = this.consumirRedirecionamentoGovBr();
                this.router.navigateByUrl(redirecionamentoPosLogin);
              }
              else{

                this.pesquisarUsuarioPorCpfPendenteAtivacao(cpfUsuarioGovBr).subscribe((usuarioPendenteAtivacao) => {

                  if (usuarioPendenteAtivacao) {
                    alert(MSG_CADASTRO_PENDENTE_ATIVACAO_USUARIO_GOV_BR);
                    this.logoutUserGovBr();


                  }
                  else{
                    localStorage.removeItem(CURRENT_USER);
                    alert(MSG_CADASTRO_USUARIO_GOV_BR);
                    this.router.navigate([USUARIO]);
                  }
                });


              }

            });

          }
          else {

            alert(ERRO_AUTENTICACAO_FALHOU);

          }

        }, messageError => { alert(this.extrairMensagemErro(messageError)); });

    }

    pesquisarUsuarioPorCpf(cpfUsuarioGovBr): Observable<any> {

      return this.http.get(`${environment.settings.api.url + URL_API.PATH_PESQUISAR_USUARIO_POR_CPF}/${cpfUsuarioGovBr}`);

    }

    pesquisarUsuarioPorCpfPendenteAtivacao(cpfUsuarioGovBr): Observable<any> {

      return this.http.get(`${environment.settings.api.url + URL_API.PATH_PESQUISAR_USUARIO_POR_CPF_PENDENTE_ATIVACAO}/${cpfUsuarioGovBr}`);

    }

    logoutUserGovBr(): void {

        localStorage.clear();
        window.location.href=`${build.url_acesso_gov_br}/logout?post_logout_redirect_uri=${build.logout_redirect_uri_gov_br}`;


    }

    refreshToken() {

      const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');

      this.http.get(`${environment.settings.api.url}` + URL_API.REFRESH_TOKEN,  { headers, responseType: 'text' } ).subscribe(token => {

        localStorage.removeItem(TIMEOUT_SESSION);
        localStorage.removeItem(JWT_TOKEN_KEY);
        localStorage.setItem(JWT_TOKEN_KEY, token);

        build.timeoutSessao = setTimeout(() => {

          if (confirm(MENSAGEM_EXPIRAR_SESSAO)) {

            this.refreshToken();

          }

        }, TEMPO_SESSAO);

        const dataExpiracao = new Date();
        dataExpiracao.setTime(Date.now() + TEMPO_SESSAO);
        localStorage.setItem(TIMEOUT_SESSION, dataExpiracao.getTime().toString());

      }, () => alert(ERRO_RENOVAR_SESSAO));

    }

}
